export default "__VITE_ASSET__DXTSoAXY__"